import { isAuthenticated } from "../../../commons/Auth/auth";
import { hasPermission } from "../../../commons/Permissions/PermissionsHook";

/**
 * Whether the signed-in user may see acceptances, warranties and bonds: the provider, or an
 * employee whose role reads the "Warranty" module. The server checks again; this only decides
 * whether to show entry points such as the project tab.
 */
export const canUseWarranty = () => {
  const user = isAuthenticated();
  if (![1, 2].includes(Number(user?.role))) return false;
  return hasPermission(user?.roleId?.permissions, "Warranty", "Read");
};
